/* eslint-disable import/no-unresolved */
import React, { useMemo } from 'react';

import RightModalLayout from '../../../../../../../../layouts/Modal/RightModalLayout';
import DropdownMC from '../../../../../../../../components/DropdownMC';

const MoveNegotiationDetailsToolView = ({
  t,
  footerSubmitLabel,
  handleBack,
  handleConfirmNegotiation,
  funnelOptions,
  selectedFunnel,
  setSelectedFunnel,
  selectedStep,
  setSelectedStep
}) => {
  const stepOptions = useMemo(
    () => (selectedFunnel
      ? funnelOptions.find((funnel) => funnel.id === selectedFunnel)?.funnel_steps || []
      : []),
    [funnelOptions, selectedFunnel]
  );

  return (
    <RightModalLayout
      closeAction={handleBack}
      title={t('tools.move_negotiation_title')}
      showBackButton
      submitLabel={footerSubmitLabel}
      submitAction={handleConfirmNegotiation}
      cancelLabel={t('Common:actions.cancel')}
      cancelAction={handleBack}
      footerVariant="VERTICAL"
    >
      <div className="tw-flex tw-flex-col tw-gap-6">
        <div>
          <div className="tw-font-bold tw-text-gray-900 tw-text-sm tw-mb-1">
            {t('tools.move_negotiation_details_title')}
          </div>
          <div className="tw-text-gray-600 tw-text-xs">
            {t('tools.move_negotiation_details_description')}
          </div>
        </div>

        <div className="tw-flex tw-flex-col tw-gap-4">
          <DropdownMC
            id="funnel_id"
            name="funnel_id"
            label={t('tools.funnel_label')}
            placeholder={t('tools.select_placeholder')}
            options={funnelOptions}
            onSelect={setSelectedFunnel}
            defaultValue={selectedFunnel}
            useFloatingLabel
          />
          <DropdownMC
            id="step_id"
            name="step_id"
            label={t('tools.stage_label')}
            placeholder={t('tools.select_placeholder')}
            options={stepOptions}
            onSelect={setSelectedStep}
            defaultValue={selectedStep}
            useFloatingLabel
          />
        </div>
      </div>
    </RightModalLayout>
  );
};

export default MoveNegotiationDetailsToolView;
